<template>
    <div class="keyword_formation_box">
        <div class="inform_tit" @click="cancel"> 
            <i class="el-icon-back myback_icon"></i> Back
        </div>
        <div class="inMain_box">
            <div class="informdata_tit" v-if="type=='a'">Add Keywords</div>
            <div class="informdata_tit" v-else>Edit Keywords</div>
            <el-form :model="ruleForm" label-position="top" :hide-required-asterisk='true' :rules="rules" ref="ruleForm" label-width="100px" class="information-ruleForm">
                <el-form-item label="Title" prop="tit">
                    <el-input v-model.number="ruleForm.tit" maxlength="50" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="Sort" prop="sort">
					<el-select v-model="ruleForm.sort" placeholder="Please Choose" class="myVenue_sel">
                        <el-option
                        v-for="item in ['Fixed OH','Variable OH']"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Keywords Name" prop="name">
                    <el-input v-model.number="ruleForm.name" placeholder="Water/Drinking water/Mineral water" type="textarea" resize='none' class="venueInformation_input increaseInput"></el-input>
					<div class="name_msgB">Each keyword is separated by "/"</div>
                </el-form-item>
                <el-form-item class="foot_box">
                    <el-button @click="cancel" class="cardCanBtn">Cancel</el-button>
                    <el-button @click="confirm" class="cardConBtn">Confirm</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import api from '../../api/category';
export default {
    data() {
        return {
			type:'a',
			rules:{
                tit: [
                    { required: true, message: ' ', trigger: 'blur' }
                ],
                sort: [
                    { required: true, message: ' ', trigger: 'change' }
                ],
                name: [
                    { required: true, message: ' ', trigger: 'blur' }
                ]
            },
            ruleForm:{
				tit:'',
				sort:'',
				name:''
            },
            id:''
        }
    },
    methods: {
        cancel(){
            this.$router.push({path:'/keywordList'})
        },
        getDetail(){
            api.getKeywords({params:{id:this.id},callback:res=>{
                let {code,message,data}=res.data;
                if(code==0){
                    this.ruleForm.tit=data.title;
                    this.ruleForm.sort=data.sort==0?'Fixed OH':'Variable OH';
                    this.ruleForm.name=data.keywords;
                }else{
                    this.$box.alert('', res.data.message, 'error')
                }
            }})
        },
        confirm(){
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    let pat={
                        keywords:this.ruleForm.name,
                        sort:this.ruleForm.sort=='Fixed OH'?0:1,
                        title:this.ruleForm.tit
                    }
                    if(this.type=='a'){
                        api.addKeywords({params:pat,callback:res=>{
                            let {code,message,data}=res.data;
                            if(code==0){
                                this.$router.push({path:'/keywordList'})
                            }else{
                                this.$box.alert('', res.data.message, 'error')
                            }
                        }})
                    }else{
                        pat.id=this.id
                        api.editKeywords({params:pat,callback:res=>{
                            let {code,message,data}=res.data;
                            if(code==0){
                                const page = window.sessionStorage.getItem('keywordPage')
                                this.$router.push({name:'keywordList',params:{page:page}})
                                window.sessionStorage.removeItem('keywordPage')
                            }else{
                                this.$box.alert('', res.data.message, 'error')
                            }
                        }})
                    }
                } else {
                    return false;
                }
            });
        }
	},
	mounted() {
		this.type=this.$route.query.type;
        this.id=this.$route.query.id;
        if(this.id){
            this.getDetail()
        }
	},
}
</script>

<style lang="scss">
    .keyword_formation_box{
        .inform_tit{
            height:20px;
            font-size:14px;
            font-weight:600;
            color:rgba(255,255,255,1);
            line-height:20px;
            cursor: pointer;
            width: 150px;
            margin-bottom: 56px;
        }
        .inMain_box{
            background-color: #2b3444;
            width: 100%;
            box-sizing: border-box;
            padding:50px 20%;
            .informdata_tit{
                text-align: left;
                margin-bottom: 50px;
                height:42px;
                font-size:30px;
                font-weight:600;
                color:rgba(255,255,255,1);
                line-height:42px;
			}
			.name_msgB{
				height:16px;
				font-size:14px;
				font-weight:400;
				color:#797f89;
				line-height:16px;
				margin-top: 10px;
			}
        }
	}
</style>


// WEBPACK FOOTER //
// src/components/CreateCategory/keyword.vue